import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { numericDuration } from 'ember-stereo/helpers/numeric-duration';

export default class DeluxePlayerPositionCurrentTimeComponent extends Component {
  @service clock;
  @service feeds;
  @service stereo;

  get loadedFeed() {
    return this.feeds.findFeed({ url: this.args.identifier });
  }

  get loadedSound() {
    return this.stereo.findSound(this.args.identifier);
  }

  get timeElapsed() {
    if (this.loadedFeed.isLive) {
      let elapsed =
        this.clock.date.getTime() -
        new Date(this.loadedFeed.airing.startsAt).getTime();
      return numericDuration([elapsed]);
    } else if (this.loadedSound) {
      return numericDuration([this.args.loadedSound.position]);
    } else {
      return 0;
    }
  }
}
